export enum Http409Message {
  SameEmail = 'email already taken',
  SameUsername = 'username already taken',
}
